export const borderRadius = <const>{
  none: 0,
  small: 4,
  medium: 6,
  large: 8,
  full: '9999px'
}

export type BorderRadius = typeof borderRadius
